/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import CRM from '../BaseComponent/CRM'

export class SendSms extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  submit(e) {
    e.preventDefault()
  }

  sendSms() {
    let mobile = document.getElementById('mobile').value
    let contents = document.getElementById('contents').value
    let mobileErr = false
    let contentsErr = false
    let formError = false
    if (mobile == '') {
      formError = true
      mobileErr = true
      message.error('موبایل وارد شود')
    } else if (!mobile.match(/^09\d{9}$/g)) {
      formError = true
      mobileErr = true
      message.error('موبایل معتبر نیست.')
    } else {
      if (!mobileErr) {
        this.setState({
          error: ''
        })
      }
    }

    if (contents == '') {
      formError = true
      contentsErr = true
      message.error('پیام وارد شود.')
    } else {
      if (!contentsErr) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        contents,
        mobile
      }
      http.post(`${CRM.CRM_CONTACT_SMS_SEND_GENERAL}`, data).then((response) => {
        if (response.data.error == null) {
          message.success('ارسال شد')
        }
      })
    }
  }

  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>

            <li>ارتباط با مشتری</li>
            <li>ارسال sms</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ارسال sms</p>
            </div>
            <div className="formComponent">
              <label>
                موبایل <span className="requireFiled">*</span>
              </label>
              <input type="text" id="mobile" className="form-control" />

              <label>
                توضیحات <span className="requireFiled">*</span>
              </label>
              <textarea name="contents" id="contents" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.sendSms.bind(this)}>
                ارسال
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
